import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from "@angular/material/dialog";
import { NotificationService } from "../../../../services/notification.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatInput } from "@angular/material/input";
import { MatError, MatFormField, MatLabel, MatPrefix } from "@angular/material/form-field";
import { TranslatePipe, TranslateService } from "@tolgee/ngx";
import { ProtocolService } from "../../../../services/protocol.service";
import { markEmailDomainError } from "../../../../validators/email-domain-error";
import { HelpButtonComponent } from "../../../help-center/help-button/help-button.component";

@Component({
	selector: "app-protocol-share-by-email",
	templateUrl: "./protocol-share-by-email.component.html",
	styleUrls: ["./protocol-share-by-email.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		MatDialogTitle,
		MatDialogContent,
		ReactiveFormsModule,
		MatFormField,
		MatLabel,
		MatInput,
		MatError,
		MatIcon,
		MatPrefix,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		MatProgressSpinner,
		TranslatePipe,
		HelpButtonComponent,
	],
})
export class ProtocolShareByEmailComponent {
	private data = inject(MAT_DIALOG_DATA);
	private formBuilder = inject(UntypedFormBuilder);
	private protocolService = inject(ProtocolService);
	private toastr = inject(NotificationService);
	private translate = inject(TranslateService);
	private dialogRef = inject<MatDialogRef<ProtocolShareByEmailComponent>>(MatDialogRef);

	isLoading = false;
	formGroup: UntypedFormGroup;

	constructor() {
		this.formGroup = this.formBuilder.group({
			email: ["", [Validators.required, Validators.email]],
		});
	}

	apply(): void {
		this.isLoading = true;
		this.protocolService.shareProtocolByEmail(this.data, this.formGroup.get("email").value).subscribe({
			next: (response) => {
				if (response.status === 204) {
					this.toastr.success(this.translate.instant("protocol.share.by-email.success"));
				} else {
					this.toastr.error(this.translate.instant("core.message.error.unknown"));
				}
				this.isLoading = false;
				this.dialogRef.close();
			},
			error: (error) => {
				this.isLoading = false;
				markEmailDomainError(error, this.formGroup.get("email"));
			},
		});
	}
}
